import { ACTIONS } from "./Calculator"

function reducer(state, { type, payload }) {
    switch (type) {
        case ACTIONS.ADD_DIGIT:
           if(state.overwrite===true){
            return {
                ...state,
                currentOperand: payload.digit,
                overwrite:false
            }
           }

            //it can not be added more than one zero in initaial state
            if (payload.digit === "0" && state.currentOperand === "0") {
                return state;
            }
            //it can not be added more than one point
            if (payload.digit === "." && state.currentOperand.includes(".")) {
                return state;
            }
            return {
                ...state,
                currentOperand: `${state.currentOperand || ""}${payload.digit}`
            }

        case ACTIONS.CHOOSE_OPERATION:
            //if there are not operand then return the state as it is
            if (state.currentOperand == null && state.previousOperand == null) {
                return state;
            }

           if(state.currentOperand == null){
            return {
                ...state,
                operation:payload.operation
            }
           }


            if (state.previousOperand == null) {
                return {
                    ...state,
                    operation: payload.operation,
                    previousOperand: state.currentOperand,
                    currentOperand: null
                }
            }

            return {
                ...state,
                previousOperand: evaluate(state),
                operation: payload.operation,
                currentOperand: null
            }
   
        case ACTIONS.EVUALATE:

           if(
            state.currentOperand == null ||
            state.previousOperand == null ||
            state.operation == null
           )return state;
           
          
            return {
              ...state,
              previousOperand:null,
              operation:null,
              currentOperand:evaluate(state),
              overwrite:true
            }


           case ACTIONS.DELETE_DIGIT:
            if(state.overwrite){
                return {
                    ...state,
                    overwrite:false,
                    currentOperand:null
                }
            }
           if(state.currentOperand == null){
            return state;
           }
           if(state.currentOperand.length===1){
            return{
                ...state,
                currentOperand:null,

            }
           }


            return {
                ...state,
                currentOperand:state.currentOperand.slice(0,-1)
            }


            case ACTIONS.CLEAR:
               return {}

        }

}

const evaluate = ({ currentOperand, previousOperand, operation }) => {
    const prev = parseFloat(previousOperand);
    const curr = parseFloat(currentOperand);
    if (isNaN(prev) || isNaN(curr)) {
        return ""
    }
    let computation = "";
    switch (operation) {
        case "+":
            computation = prev + curr;
            break;
        case "*":
            computation = prev * curr;
            break;
        case "-":
            computation = prev - curr;
            break;
        case "/":
            computation = prev / curr;
            break;
        case "%":
            computation =prev%curr;
            break;
    }
    return computation.toString();
}

export { reducer }